export const contactsData = {
  email: "ahmedahmedraja@gmail.com",
  phone: "+27812177330",
  address: "Snell Parade, Durban, South Africa - 4001 ",

  sheetAPI: "https://sheetdb.io/",
};
